var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _c("div", { staticClass: "ai-header-banner" }, [
        _c("div", { staticClass: "banner-overlay" }),
        _c("div", { staticClass: "banner-content" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "banner-actions" },
            [
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn green-btn",
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.handleOpenAddAccountBankToBrandDialog },
                },
                [_vm._v("\n          Thêm tài khoản có sẵn\n        ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ai-stats-grid" }, [
        _c("div", { staticClass: "stat-card blue" }, [
          _vm._m(1),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Tổng tài khoản liên kết"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.totalPage)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card green" }, [
          _vm._m(2),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Liên kết thành công (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.connectedCount)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card purple" }, [
          _vm._m(3),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Đã xác thực OTP (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.otpCount)),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "glass-card mb-4" },
        [
          _c(
            "el-form",
            {
              staticClass: "modern-filter-form",
              attrs: { inline: true, model: _vm.dataSearch },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Trường học" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Tất cả các trường",
                      },
                      on: { change: _vm.findAllData },
                      model: {
                        value: _vm.dataSearch.idSchool,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "idSchool", $$v)
                        },
                        expression: "dataSearch.idSchool",
                      },
                    },
                    _vm._l(_vm.schoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          value: item.id,
                          label: `${item.id} - ${item.schoolName}`,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Liên kết API" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        clearable: "",
                        placeholder: "Tất cả trạng thái",
                      },
                      on: { change: _vm.findAllData },
                      model: {
                        value: _vm.dataSearch.statusBankApiConnected,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.dataSearch,
                            "statusBankApiConnected",
                            $$v
                          )
                        },
                        expression: "dataSearch.statusBankApiConnected",
                      },
                    },
                    _vm._l(_vm.listStatusBankApiConnected, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Công nợ" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        clearable: "",
                        placeholder: "Trạng thái công nợ",
                      },
                      on: { change: _vm.findAllData },
                      model: {
                        value: _vm.dataSearch.statusBillPayment,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "statusBillPayment", $$v)
                        },
                        expression: "dataSearch.statusBillPayment",
                      },
                    },
                    _vm._l(_vm.listStatusBillPayment, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái xóa" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: { placeholder: "Trạng thái xóa" },
                      on: { change: _vm.findAllData },
                      model: {
                        value: _vm.dataSearch.delActive,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "delActive", $$v)
                        },
                        expression: "dataSearch.delActive",
                      },
                    },
                    _vm._l(_vm.listActive, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Số tài khoản" } },
                [
                  _c("el-input", {
                    staticClass: "modern-input",
                    attrs: {
                      clearable: "",
                      placeholder: "Nhập số tài khoản...",
                      "prefix-icon": "el-icon-search",
                    },
                    on: { clear: _vm.findAllData },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.findAllData.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.dataSearch.accountNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "accountNumber", $$v)
                      },
                      expression: "dataSearch.accountNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.findAllData },
                    },
                    [_vm._v("Lọc dữ liệu")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table",
                },
              ],
              ref: "multipleTable",
              staticClass: "modern-table",
              attrs: {
                data: _vm.dataTable,
                "element-loading-text":
                  "Đang tải danh sách tài khoản liên kết...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
                "max-height": _vm.tableMaxHeight,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.calculateStt,
                  label: "STT",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tên trường học",
                  "min-width": "240",
                  prop: "schoolName",
                  fixed: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "school-name-text" }, [
                          _c("i", {
                            staticClass: "el-icon-school",
                            staticStyle: {
                              color: "#64748b",
                              "margin-right": "4px",
                            },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(row.schoolName) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Đại lý quản lý",
                  "min-width": "180",
                  prop: "companyName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "brand-full-name" }, [
                          _vm._v(_vm._s(row.companyName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Thông số ID SePay",
                  "min-width": "180",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticClass: "id-sepay-block" }, [
                          _c("span", { staticClass: "sub-label" }, [
                            _vm._v("Đại lý:"),
                          ]),
                          _c("code", { staticClass: "code-badge" }, [
                            _vm._v(_vm._s(row.xidCompany)),
                          ]),
                          _c("span", { staticClass: "sub-label mt-1" }, [
                            _vm._v("Ngân hàng:"),
                          ]),
                          _c("code", { staticClass: "code-badge" }, [
                            _vm._v(_vm._s(row.xidBankAccount)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Chủ tài khoản",
                  "min-width": "200",
                  prop: "accountHolderName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "holder-name" }, [
                          _vm._v(_vm._s(row.accountHolderName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Thông tin tài khoản", "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticClass: "account-info-block" }, [
                          _c("span", { staticClass: "account-num" }, [
                            _vm._v(_vm._s(row.accountNumber)),
                          ]),
                          _c("span", { staticClass: "bank-tag" }, [
                            _vm._v(_vm._s(row.bankName)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tên gợi nhớ",
                  "min-width": "160",
                  prop: "label",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "label-text" }, [
                          _vm._v(_vm._s(row.label || "—")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Hiển thị QR",
                  width: "110",
                  align: "center",
                  prop: "showQR",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-checkbox", {
                          attrs: {
                            disabled:
                              !row.bankApiConnected || !row.authenticationOTP,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleChangeShow(row)
                            },
                          },
                          model: {
                            value: row.showQR,
                            callback: function ($$v) {
                              _vm.$set(row, "showQR", $$v)
                            },
                            expression: "row.showQR",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Ưu tiên",
                  width: "90",
                  align: "center",
                  prop: "priority",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Sử dụng TK ảo nhận biến động SD",
                  width: "200",
                  align: "center",
                  prop: "showQR",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-checkbox", {
                          on: {
                            change: function ($event) {
                              return _vm.handleChangeUpdateUseVASynchronization(
                                row
                              )
                            },
                          },
                          model: {
                            value: row.useVASynchronization,
                            callback: function ($$v) {
                              _vm.$set(row, "useVASynchronization", $$v)
                            },
                            expression: "row.useVASynchronization",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Số tài khoản ảo",
                  width: "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.seAccountVADtos && row.seAccountVADtos.length > 0
                          ? _c(
                              "span",
                              {
                                staticClass: "va-badge-clickable",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClickFindListVA(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(row.seAccountVADtos.length) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _c("span", { staticClass: "text-muted" }, [
                              _vm._v("0"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Giao dịch trong tháng",
                  "min-width": "220",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticClass: "money-stats" }, [
                          _c("div", { staticClass: "money-row green-text" }, [
                            _c("span", { staticClass: "m-label" }, [
                              _vm._v("Tổng tiền vào:"),
                            ]),
                            _c("span", { staticClass: "m-val" }, [
                              _vm._v(
                                _vm._s(_vm._f("formatCurrency")(row.sumMoneyIn))
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "money-row red-text mt-1" },
                            [
                              _c("span", { staticClass: "m-label" }, [
                                _vm._v("Tổng tiền ra:"),
                              ]),
                              _c("span", { staticClass: "m-val" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(row.sumMoneyOut)
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Kết nối API",
                  width: "160",
                  align: "center",
                  prop: "bankApiConnected",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "status-badge",
                            class: row.bankApiConnected ? "online" : "offline",
                          },
                          [
                            _c("span", { staticClass: "dot" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.bankApiConnected
                                    ? "Đã liên kết"
                                    : "Chưa liên kết"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Xác thực OTP",
                  width: "160",
                  align: "center",
                  prop: "authenticationOTP",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "status-badge",
                            class: row.authenticationOTP ? "online" : "offline",
                          },
                          [
                            _c("span", { staticClass: "dot" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.authenticationOTP
                                    ? "Đã xác thực"
                                    : "Chưa xác thực"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Hoàn thành công nợ",
                  width: "160",
                  align: "center",
                  prop: "billPaymentStatus",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-checkbox", {
                          attrs: { disabled: "" },
                          model: {
                            value: row.billPaymentStatus,
                            callback: function ($$v) {
                              _vm.$set(row, "billPaymentStatus", $$v)
                            },
                            expression: "row.billPaymentStatus",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "GD cuối",
                  "min-width": "180",
                  prop: "lastTransaction",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "date-time-text" }, [
                          _vm._v(_vm._s(row.lastTransaction || "—")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper mt-3 flex justify-center" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.dataSearch.page,
                  "page-sizes": _vm.listSizePage,
                  "page-size": _vm.dataSearch.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalPage,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentPageChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.dataSearch, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.dataSearch, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("UnConnectionBanksDialog", {
        attrs: {
          showUnConnectionBanksDialog: _vm.showUnConnectionBanksDialog,
          request_id: _vm.request_id,
          bank: _vm.bank,
        },
        on: { closeDialog: _vm.closeUnConnectionBanksDialog },
      }),
      _c("AccountVADialog", {
        attrs: {
          showQRMainAccount: _vm.showQRMainAccount,
          showAccountVADialog: _vm.showAccountVADialog,
          listVA: _vm.listVA,
          bank: _vm.bank,
          actionToAdmin: _vm.actionToAdmin,
        },
        on: { closeDialog: _vm.handleCloseAccountVADialog },
      }),
      _c("AddAccountBankToBrandDialog", {
        attrs: {
          isOpenAddAccountBankToBrandDialog:
            _vm.isOpenAddAccountBankToBrandDialog,
        },
        on: { closeDialog: _vm.handleCloseAddAccountBankToBrandDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-link" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("DANH SÁCH NGÂN HÀNG LIÊN KẾT TRƯỜNG"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Quản lý tài khoản ngân hàng nhà trường liên kết qua cổng SePay, đối soát dòng tiền và trạng thái công nợ."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-bank" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-refresh" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }